import { createStyles } from 'antd-style'

import { QuotaEntity } from '@eastcoal/api/trade/interface'

import { getQuotaParamsValue } from '../../../../utils/getQuotaParamsValue'

const useStyles = createStyles(
  ({ token }, { qutoLen }: { qutoLen: number }) => ({
    row: {
      display: 'grid',
      gridTemplateColumns: `repeat(${qutoLen},1fr)`,
      padding: token.paddingSM,
      textAlign: 'center',
      whiteSpace: 'nowrap'
    },
    name: {
      position: 'relative',
      backgroundColor: token.colorFillTertiary,
      padding: token.paddingXS,
      paddingBlockEnd: 'unset',
      [`&:not(:first-of-type)::before`]: {
        [`content`]: '""',
        position: 'absolute',
        top: '20px',
        height: '1.6em',
        insetInlineStart: '0px',
        width: '1px',
        background: 'rgba(0,0,0,0.06)'
      }
    },
    unit: {
      backgroundColor: token.colorFillTertiary,
      color: token.colorTextTertiary,
      borderBlockEnd: `1px solid ${token.colorBorderSecondary}`
    },
    value: {
      padding: token.paddingXS
    }
  })
)

export const ListQuotas = ({ quotas }: { quotas: QuotaEntity[] }) => {
  const { styles } = useStyles({ qutoLen: quotas.length })
  return (
    <div className={styles.row}>
      {quotas.map((quota, index) => (
        <div key={`name_${index}`} className={styles.name}>
          {quota.name ?? '-'}
        </div>
      ))}
      {quotas.map((quota, index) => (
        <div key={`unit_${index}`} className={styles.unit}>
          {quota.unit ?? '-'}
        </div>
      ))}
      {quotas.map((quota, index) => (
        <div key={`value_${index}`} className={styles.value}>
          {getQuotaParamsValue(quota)}
        </div>
      ))}
    </div>
  )
}
